module.exports = __webpack_public_path__ + "img/icon-add-phone-number.cca6b5ee.svg";